export const ORG_FORM_NAMES: Record<string, string> = {
  AAFY: "Allment partnerskap",
  ADOS: "Administrativ enhet - Loss offentlig sektor",
  ANNA: "Annet",
  ANS: "Ansvarlig selskap",
  AS: "Aksjeselskap",
  ASA: "Allmennaksjeselskap",
  BA: "Selskap med begrenset ansvar",
  BBL: "Boligbyggelag",
  BRL: "Borettslag",
  DA: "Selskap med delt ansvar",
  ENK: "Enkeltpersonforetak",
  EOEFG: "Europeisk økonomisk foretaksgruppe",
  ESEK: "Eierseksjonssameie",
  FKF: "Fylkeskommunalt foretak",
  FLI: "Forening/lag/innretning",
  FYLK: "Fylkeskommune",
  GFS: "Gjensidig forsikringsselskap",
  IKS: "Interkommunalt selskap",
  KBO: "Kommunalt foretak",
  KF: "Kommunalt foretak",
  KIRK: "Kirkelig fellesråd",
  KOMM: "Kommune",
  KS: "Kommandittselskap",
  NUF: "Norskregistrert utenlandsk foretak",
  OPMV: "Organisasjonsledd",
  ORGL: "Organisasjonsledd",
  PK: "Pensjonskasse",
  PRE: "Partrederi",
  SA: "Samvirkeforetak",
  SE: "Europeisk selskap",
  SF: "Statsforetak",
  SPA: "Sparebank",
  STAT: "Staten",
  STI: "Stiftelse",
  TVAM: "Tvangsregistrert enhet",
  VPFO: "Verdipapirfond",
  // Finland (PRH). SE (European company) is shared with Norway above.
  AY: "Avoin yhtiö",
  AYH: "Aatteellinen yhdistys",
  ETS: "Eurooppalaisen taloudellisen etuyhtymän sivutoimipaikka",
  ETY: "Eurooppalainen taloudellinen etuyhtymä",
  HY: "Hypoteekkiyhdistys",
  KOY: "Keskinäinen kiinteistöosakeyhtiö",
  KVJ: "Julkinen keskinäinen vakuutusyhtiö",
  KVY: "Keskinäinen vakuutusyhtiö",
  KY: "Kommandiittiyhtiö",
  OK: "Osuuskunta",
  OP: "Osuuspankki",
  OY: "Osakeyhtiö",
  OYJ: "Julkinen osakeyhtiö",
  SCE: "Eurooppaosuuskunta",
  SCP: "Eurooppaosuuspankki",
  SL: "Sivuliike",
  SP: "Säästöpankki",
  SÄÄ: "Säätiö",
  TYH: "Taloudellinen yhdistys",
  VALTLL: "Valtion liikelaitos",
  VOJ: "Julkinen vakuutusosakeyhtiö",
  VOY: "Vakuutusosakeyhtiö",
  VY: "Vakuutusyhdistys",
};
